import { useEffect, useState } from "react";
import { IoTimerOutline, IoAddOutline } from "react-icons/io5";
import { IoIosArrowDown } from "react-icons/io";
import { FaCaretDown } from "react-icons/fa";
import { Dropdown } from "react-bootstrap";
import { useContext } from "react";
import VideoContext from "../../store/video-context";
import CreatableSelect from "react-select/creatable";
import { toast } from "react-toastify";

const VideoTag = (props: any) => {
  const vContext = useContext(VideoContext);
  console.log("yesvc",vContext.tagData);
  const [tagType, setTagType] = useState(vContext.videoData.txData[0].transmission_ppt_id == "1" ? "Topics" : "Instruments");
  
  const [stepListOptions, setStepListOptions] = useState(
    vContext.videoData.txData[0].transmission_ppt_id == "1" ?
    []
    :
    vContext.tagData.steps.map((sL: any) => {
      return { label: sL.step_name, value: sL.indexstep_master_id };
    })
  );
  const [newTagValue, setNewTagValue] = useState({
    name: "",
    description: "",
  } as any);
  const [selectedForTag, setSelectedForTag] = useState({} as any);
  const [tagData, setTagData] = useState(vContext.tagData as any);

  // Flag Declaration Starts
  const [isAddNew, setIsAddNew] = useState(false);
  const [isBtnDisable, setIsBtnDisable] = useState(true);
  // Flag Declaration Ends
console.log("yes111" + vContext.videoData.topic);
console.log("yes111" + JSON.stringify(vContext.tagData));
  //Effect declaration Starts
  useEffect(() => {
    let tagDataCopy: any = tagData;
    
    tagDataCopy[tagType.toLowerCase()].find((f: any) => f.isChecked === true)
      ? setIsBtnDisable(false)
      : setIsBtnDisable(true);

      setIsBtnDisable(false) //added by vinaya
  }, [tagData]);

  useEffect(() => {
    setIsBtnDisable(!isAddNew);
    if (isAddNew) {
      setTagDataHandler();
    }
  }, [isAddNew]);
  //Effect declaration Starts

  //Functions definations Starts
  const convertSecondToHH_MM_SS = (seconds: any) => {
    return new Date(seconds * 1000).toISOString().substr(11, 8);
  };
  const setTagDataHandler = () => {
    setTagData((preTagData: any) => {
      return {
        ...preTagData,
        [tagType.toLowerCase()]: preTagData[tagType.toLowerCase()].map(
          (i: any) => {
            return { ...i, isChecked: false };
          }
        ),
      };
    });
  };

  function menuClick(e: any) {
    console.log("yes"+"clicked");
    setTagDataHandler();
    setIsAddNew(false);
    setTagType(e.target.attributes.getNamedItem("menuname").value);
    setIsBtnDisable(true);

  
  }

  const handleChange = (newValue: any, actionMeta: any) => {
    console.group("Value Changed");
    // console.log(newValue);
    // console.log(`action: ${actionMeta.action}`);
    if (actionMeta.action === "create-option") {
      let options = stepListOptions;
      options.push({ label: newValue.label, value: "0" });
      setStepListOptions(options);
      setNewTagValue((preValue: any) => {
        return { ...preValue, name: newValue.label };
      });
      setIsAddNew(!isAddNew);
    }
    if (actionMeta.action === "select-option" && newValue !== null) {
      setTagData((preTagData: any) => {
        return {
          ...preTagData,
          [tagType.toLowerCase()]: preTagData[tagType.toLowerCase()].map(
            (i: any) =>
              i.indexstep_master_id === newValue.value
                ? { ...i, isChecked: true }
                : { ...i, isChecked: false }
          ),
        };
      });
    } else {
      setTagData((preTagData: any) => {
        return {
          ...preTagData,
          [tagType.toLowerCase()]: preTagData[tagType.toLowerCase()].map(
            (i: any) => {
              return { ...i, isChecked: false };
            }
          ),
        };
      });
    }
    if (
      isAddNew &&
      (actionMeta.action === "clear" ||
        actionMeta.action === "input-change" ||
        actionMeta.action === "select-option")
    ) {
      setStepListOptions((preOptions: any) =>
        preOptions.filter((f: any) => f.value !== "0")
      );
      setIsAddNew(!isAddNew);
      setNewTagValue((preValue: any) => {
        preValue.name = "";
        preValue.description = "";
      });
    }
    console.groupEnd();
  };

  const handleInputChange = (inputValue: any, actionMeta: any) => {
    console.group("Input Changed");
 
    // console.log(inputValue);
    // console.log(`action: ${actionMeta.action}`);
    console.groupEnd();
  };

  const newTagInputHandler = (e: any) => {
    let value = e.target.value;
    value.length >=0 ? setIsBtnDisable(false) : setIsBtnDisable(true);
    if (tagType !== "Steps" && tagType !== "Topics" ) {
      setNewTagValue((preValue: any) => {
        return { ...preValue, name: value };
      });
    } 
      else {
      setNewTagValue((preValue: any) => {
        return { ...preValue, description: value };
      });
    }
  };

  const changeTagHandler = (e: any, item: any) => {
    e.preventDefault();
    setTagData((preTagData: any) => {
      if (tagType === "Instruments") {
        return {
          ...preTagData,
          [tagType.toLowerCase()]: preTagData[tagType.toLowerCase()].map(
            (i: any) =>
              i.equipment_id === item.equipment_id
                ? { ...i, isChecked: !item.isChecked }
                : { ...i, isChecked: false }
          ),
        };
      } else if (tagType === "Anatomy") {
        return {
          ...preTagData,
          [tagType.toLowerCase()]: preTagData[tagType.toLowerCase()].map(
            (a: any) =>
              a.organ_id === item.organ_id
                ? { ...a, isChecked: !item.isChecked }
                : { ...a, isChecked: false }
          ),
        };
      }
    });
    setIsAddNew(false);
    setSelectedForTag(item);
  };

  const cancelActionHandler = () => {
    document.body.click();
    props.closePopup();
  };

  const addActionHandler = () => {
    // console.log("addAction");
    if (isAddNew) {
      switch (tagType) {
        case "Steps":
          addNewStepHandler();
          break;
        case "Anatomy":
          addNewAnatomyHandler();

          break;
        case "Instruments":
          addNewEquipmentHandler();
          break;
          case "Topics":
            addNewStepHandler();
            break;
        default:
          break;
      }


    } else {
      switch (tagType) {
        case "Steps":
          tagStepHandler(
            tagData.steps.find((f: any) => f.isChecked === true)
              .indexstep_master_id
          );
          break;
          case "Topics":
            
            break;
        case "Anatomy":
          tagAnatomyHandler(
            tagData.anatomy.find((f: any) => f.isChecked === true).organ_id
          );
          break;
        case "Instruments":
          tagEquipmentHandler(
            tagData.instruments.find((f: any) => f.isChecked === true)
              .equipment_id
          );
          break;
        default:
          break;
      }
     
       document.body.click();
      props.closePopup();
    }
  };



// console.log("yes" + JSON.stringify(vContext.videoData));
  // Steps tagging
  const tagStepHandler = (stepId: any) => {
    if(vContext.videoData.txData[0].transmission_ppt_id == "1"){
      fetch(
        "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=tagLectureTopic&transID=" +
        vContext.transId +
       "&title=" +
       newTagValue.name +
       "&desc="+
       newTagValue.description +
        "&time=" +
        vContext.videoTime

      )
        .then((res) => res.json())
        .then((newTopic) => {
          // console.log('newStep', newStep);
          if (newTopic.status === "success") {
            document.body.click();
            props.closePopup();
        let data = {
          id: newTopic.data[0].id,
          name: isAddNew ? newTagValue.name : newTagValue.name,
          desc: isAddNew ? newTagValue.description : newTagValue.description,
          flag: "topic",
          time: vContext.videoTime,
        };
        console.log('after tagging', data);
        vContext.pushAccordionDataHandler(data);
            toast.dark("New Topic Tagged Successfully!", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            // console.log('Fail new step');
            toast.dark("Tagging New Topic Failed!", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch((error) => {
          console.error("Error:(addNewStepHandler)", error);
        });


    } else{
           fetch(
          "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=tagIndexstep&transID=" +
            vContext.transId +
            "&userID=" +
            vContext.userId +
            "&stepId=" +
            stepId +
            "&time=" +
            vContext.videoTime
        )
          .then((res) => res.json())
          .then((tagStep) => {
            if (tagStep.status === "success") {
              // console.log("selected step", selectedForTag);
              document.body.click();
              props.closePopup();
              let selected = tagData.steps.find((f: any) => f.isChecked === true);
              let data = {
                id: tagStep.data[0].id,
                name: isAddNew ? newTagValue.name : selected.step_name,
                desc: isAddNew ? newTagValue.description : selected.step_desc,
                flag: "indexstep",
                time: vContext.videoTime,
              };
              // console.log('after tagging', data);
              vContext.pushAccordionDataHandler(data);
              toast.dark("Step Tagged Successfully!", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            } else {
              // console.log('Fail tag step');
              toast.dark("Step Tagging Failed!", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          })
          .catch((error) => {
            console.error("Error:(tagStepHandler)", error);
          });
        }
  };


  // Anatomy tagging
  const tagAnatomyHandler = (anatomyID: any) => {
    fetch(
      "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=tagAnatomy&transID=" +
        vContext.transId +
        "&anatomyID=" +
        anatomyID +
        "&xPosition=" +
        vContext.tagPosition.x +
        "&yPosition=" +
        vContext.tagPosition.y +
        "&time=" +
        vContext.videoTime
    )
      .then((res) => res.json())
      .then((tagAnatomy) => {
        if (tagAnatomy.status === "success") {
          document.body.click();
        props.closePopup();
          // console.log("selected anatomy", selectedForTag );
          let data = {
            id: tagAnatomy.data,
            anatomy_id: anatomyID,
            name: isAddNew ? newTagValue.name : selectedForTag.organ_name,
            desc: "",
            time: vContext.videoTime,
            x_position: vContext.tagPosition.x,
            y_position: vContext.tagPosition.y,
            flag: "anatomy",
          };
          // console.log('after tagging', data);
          vContext.pushAccordionDataHandler(data);
          toast.dark("Anatomy Tagged Successfully!", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          // console.log('Fail tag step');
          toast.dark("Anatomy Tagging Failed!", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch((error) => {
        console.error("Error:(tagAnatomyHandler)", error);
      });
  };

  //Equipment tagging
  const tagEquipmentHandler = (equipmentID: any) => {
    fetch(
      "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=tagEquipment&transID=" +
        vContext.transId +
        "&equipmentID=" +
        equipmentID +
        "&xPosition=" +
        vContext.tagPosition.x +
        "&yPosition=" +
        vContext.tagPosition.y +
        "&time=" +
        vContext.videoTime +
        "&userID=" +
        vContext.userId
    )
      .then((res) => res.json())
      .then((tagEquipment) => {
        if (tagEquipment.status === "success") {
          // console.log("selected",selectedForTag);
          document.body.click();
          props.closePopup();
          let data = {
            id: tagEquipment.data[0].id,
            equipment_id: equipmentID,
            name: isAddNew ? newTagValue.name : selectedForTag.equipment_name,
            desc: "",
            time: vContext.videoTime,
            x_position: vContext.tagPosition.x,
            y_position: vContext.tagPosition.y,
            flag: "equipment",
          };
          // console.log('after tagging', data);
          vContext.pushAccordionDataHandler(data);

         
          if(isAddNew)
          {
          let newData = {
            equipment_id: equipmentID,
            equipment_name: isAddNew ? newTagValue.name : selectedForTag.equipment_name,
            equipment_link: "",
            anatomy_equip_id: "",
            anatomy_id: "",
            hospital_buy_product: "",
            company_id: 0,
          };

          let equipmentsData : any;
          equipmentsData = tagData.instruments;
          equipmentsData.push(newData);
          var newTagData = {
            instruments: equipmentsData,
            steps: tagData.steps,
            anatomy: tagData.anatomy,

          };
         
          setTagData(newTagData);
          vContext.setTagDataHandler(newTagData);
        }
         
          toast.dark("Instrument Tagged Successfully!", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          // console.log('Fail tag step');
          toast.dark("Instrument Tagging Failed!", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch((error) => {
        console.error("Error:(tagEquipmentHandler)", error);
      });

     
  };


  // Adding new step details
  const addNewStepHandler = () => {
    if(vContext.videoData.txData[0].transmission_ppt_id == "1"){
   
      fetch(
        "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=getVideoData&transID=" +
          vContext.transId +
        "&userID="+
        vContext.userId +
        "&flag=topic"
      )
        .then((res) => res.json())
        .then((newTopic) => {
          // console.log('newStep', newStep);
          if (newTopic.status === "success") {
            tagStepHandler(newTopic.data[0].id);
            toast.dark("New Topic Added Successfully!", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            // console.log('Fail new step');
            toast.dark("Adding New Topic Failed!", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch((error) => {
          console.error("Error:(addNewStepHandler)", error);
        });
    }else{
      fetch(
        "https://www.lapguru.com/lapguruWebservice/LapguruRESTHandler.php?command=addIndexstep&transID=" +
          vContext.transId +
          "&userID=" +
          vContext.userId +
          "&stepName=" +
          newTagValue.name +
          "&stepDesc=" +
          newTagValue.description
      )
        .then((res) => res.json())
        .then((newStep) => {
          // console.log('newStep', newStep);
          if (newStep.status === "success") {
            tagStepHandler(newStep.data[0].id);
            toast.dark("New Step Added Successfully!", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            // console.log('Fail new step');
            toast.dark("Adding New Step Failed!", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch((error) => {
          console.error("Error:(addNewStepHandler)", error);
        });

    
   

    }
    

  
  }
   
  

  // Adding new anatomy details
  const addNewAnatomyHandler = () => {
    fetch(
      "https://www.lapguru.com//lapguruWebservice/LapguruRESTHandler.php?command=addAnatomy&transID=" +
        vContext.transId +
        "&anatomyName=" +
        newTagValue.name
    )
      .then((res) => res.json())
      .then((newAnatomy) => {
        // console.log('newAnatomy', newAnatomy);
        if (newAnatomy.status === "success") {
          tagAnatomyHandler(newAnatomy.data[0].id);
          toast.dark("New Anatomy Added Sucessully!", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          // console.log('Fail new Anatomy');
          toast.dark("Adding New Anatomy Failed!", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch((error) => {
        console.error("Error:(addNewAnatomyHandler)", error);
      });
  };

  // Adding new Equipment details
  const addNewEquipmentHandler = () => {
    fetch(
      "https://www.lapguru.com//lapguruWebservice/LapguruRESTHandler.php?command=addEquipment&transID=" +
        vContext.transId +
        "&equipmentName=" +
        newTagValue.name
    )
      .then((res) => res.json())
      .then((newEquipment) => {
        // console.log('newEquipment', newEquipment);
        if (newEquipment.status === "success") {
          tagEquipmentHandler(newEquipment.data[0].id);
          toast.dark("New Instrument Added Sucessully!", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          // console.log('Fail new Equipment');
          toast.dark("Adding New Instrument Failed!", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch((error) => {
        console.error("Error:(addNewEquipmentHandler)", error);
      });
  };
  //Functions definations Ends

  //Actual Component HTML Starts
  return (
    <div className={`video-popover-body ${tagType.toLowerCase()}-body`}>
      <div className="video-popover-header">
        {vContext.videoData.txData[0].transmission_ppt_id == "1" ? (
          <>
            <Dropdown className="popover-selector">
              <Dropdown.Toggle
                as="div"
                id="popover-selector"
                className={`d-flex align-items-center justify-content-between ${tagType.toLowerCase()}-toggle`}
              >
                <span className="d-flex align-items-center">
                  <FaCaretDown size={26} className="legend-toggle" />
                  <span>{tagType}</span>
                </span>
                <IoIosArrowDown size={26} className="down-arrow" />
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ width: "100%" }}>
                <Dropdown.Item
                  href="#"
                  className="d-flex align-items-center legend-instruments"
                  onClick={menuClick}
                  menuName="Instruments"
                >
                  <FaCaretDown size={26} /> Instruments
                </Dropdown.Item>
                <Dropdown.Item
                  href="#"
                  className="d-flex align-items-center legend-steps"
                  onClick={menuClick}
                  menuName="Topics"
                >
                  <FaCaretDown size={26} /> Topics
                </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
          </>
        ) : (
          <>
            <Dropdown className="popover-selector">
              <Dropdown.Toggle
                as="div"
                id="popover-selector"
                className={`d-flex align-items-center justify-content-between ${tagType.toLowerCase()}-toggle`}
              >
                <span className="d-flex align-items-center">
                  <FaCaretDown size={26} className="legend-toggle" />{" "}
                  <span>{tagType}</span>
                </span>
                <IoIosArrowDown size={26} className="down-arrow" />
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ width: "100%" }}>
                <Dropdown.Item
                  href="#"
                  className="d-flex align-items-center legend-instruments"
                  onClick={menuClick}
                  menuName="Instruments"
                >
                  <FaCaretDown size={26} /> Instruments
                </Dropdown.Item>
                {(vContext.userRole === "admin" ||
                  vContext.userRole === "moderator") && (
                  <>
                    <Dropdown.Item
                      href="#"
                      className="d-flex align-items-center legend-steps"
                      onClick={menuClick}
                      menuName="Steps"
                    >
                      <FaCaretDown size={26} /> Steps
                    </Dropdown.Item>
                    <Dropdown.Item
                      href="#"
                      className="d-flex align-items-center legend-anatomy"
                      onClick={menuClick}
                      menuName="Anatomy"
                    >
                      <FaCaretDown size={26} /> Anatomy
                    </Dropdown.Item>
                  </>
                )}
              </Dropdown.Menu>
            </Dropdown>
          </>
        )}
      </div>
      {vContext.videoData.txData[0].transmission_ppt_id == "1" ? (
        <>
          <div
            className={`video-popover-container ${tagType.toLowerCase()}-container`}
          >
            <div className="video-time-container d-inline-block">
              <div className="d-flex align-items-center video-time">
                <IoTimerOutline className="mr-1" />
                {convertSecondToHH_MM_SS(vContext.videoTime)}
              </div>
            </div>

            {tagType == "Topics" && (
            
              <div className="video-instruments-list">
                <div className="w-100">
                  <CreatableSelect
                    isClearable
                    onChange={handleChange}
                    onInputChange={handleInputChange}
                    options={stepListOptions}
                  />
                </div>
              </div>
            )}
            {(isAddNew && tagType === "Topics")  && (
              <div className="description-input mt-2">
                <textarea
                  className="w-100"
                  placeholder="Description"
                  onChange={(e: any) => {
                    newTagInputHandler(e);
                  }}
                />
              </div>
            )}
              {tagType == "Instruments" && (
                
              <div className="video-instruments-list">
                {tagData.instruments.map((item: any, i: any) => (
                  <div
                    className="video-instruments-item"
                    onClick={(e) => {
                      changeTagHandler(e, item);
                    }}
                    key={i}
                  >
                    <input
                      type="checkbox"
                      id={item.equipment_id}
                      checked={item.isChecked}
                    />
                    <label htmlFor={item.equipment_id}>
                      {item.equipment_name}
                    </label>
                  </div>
                ))}
                   <div
                  className="video-instruments-add"
                  onClick={() => {
                    setIsAddNew(!isAddNew);
                  }}
                >
                  <div className="d-flex align-items-center">
                    <IoAddOutline className="mr-2" />
                    {isAddNew ? "Cancel Add Instrument" : "Add Instrument"}
                  </div>
                </div>
              </div>
            )}
             {(isAddNew && tagType === "Instruments") && (
              <div className="description-input my-2">
                <input
                  className="w-100"
                  placeholder={`Enter ${tagType}`}
                  type="textbox"
                  onChange={(e: any) => {
                    newTagInputHandler(e);
                  }}
                />
              </div>
            )}
            <div className="video-popover-footer">
              <div
                className="action-btn cancel-btn mr-2"
                onClick={() => {
                  cancelActionHandler();
                }}
              >
                Cancel
              </div>
              <div
                className={
                  "action-btn add-btn " + (isBtnDisable ? "disabledbutton" : "")
                }
                onClick={(e:any) => {
                  addActionHandler();
                }}
              >
                Add
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div
            className={`video-popover-container ${tagType.toLowerCase()}-container`}
          >
            <div className="video-time-container d-inline-block">
              <div className="d-flex align-items-center video-time">
                <IoTimerOutline className="mr-1" />
                {convertSecondToHH_MM_SS(vContext.videoTime)}
              </div>
            </div>

            {tagType === "Instruments" && (
              <div className="video-instruments-list">
                {tagData.instruments.map((item: any, i: any) => (
                  <div
                    className="video-instruments-item"
                    onClick={(e) => {
                      changeTagHandler(e, item);
                    }}
                    key={i}
                  >
                    <input
                      type="checkbox"
                      id={item.equipment_id}
                      checked={item.isChecked}
                    />
                    <label htmlFor={item.equipment_id}>
                      {item.equipment_name}
                    </label>
                  </div>
                ))}
                {/* {isAddNew &&
          <input type="textbox" onChange={(e:any)=>{newTagInputHandler(e)}}/>
        } */}

                <div
                  className="video-instruments-add"
                  onClick={() => {
                    setIsAddNew(!isAddNew);
                  }}
                >
                  <div className="d-flex align-items-center">
                    <IoAddOutline className="mr-2" />
                    {isAddNew ? "Cancel Add Instrument" : "Add Instrument"}
                  </div>
                </div>
              </div>
            )}
            {tagType === "Anatomy" && (
              <div className="video-instruments-list">
                {tagData.anatomy.map((item: any, i: any) => (
                  <div
                    className="video-instruments-item"
                    onClick={(e) => {
                      changeTagHandler(e, item);
                    }}
                    key={i}
                  >
                    <input
                      type="checkbox"
                      id={item.organ_id}
                      checked={item.isChecked}
                    />
                    <label htmlFor={item.organ_id}>{item.organ_name}</label>
                  </div>
                ))}
                {/* {isAddNew &&
          <input type="textbox" onChange={(e:any)=>{newTagInputHandler(e)}}/>
        } */}
                <div
                  className="video-instruments-add"
                  onClick={() => {
                    setIsAddNew(!isAddNew);
                  }}
                >
                  <div className="d-flex align-items-center">
                    <IoAddOutline className="mr-2" />
                    {isAddNew ? "Cancel Add Anatomy" : "Add Anatomy"}
                  </div>
                </div>
              </div>
            )}
            {tagType === "Steps"  && (
              <div className="video-instruments-list">
                <div className="w-100">
                  <CreatableSelect
                    isClearable
                    onChange={handleChange}
                    onInputChange={handleInputChange}
                    options={stepListOptions}
                  />
                </div>
              </div>
            )}

            {isAddNew && (tagType === "Anatomy" || tagType === "Instruments") && (
              <div className="description-input my-2">
                <input
                  className="w-100"
                  placeholder={`Enter ${tagType}`}
                  type="textbox"
                  onChange={(e: any) => {
                    newTagInputHandler(e);
                  }}
                />
              </div>
            )}
            {(isAddNew && tagType === "Steps")  && (
              <div className="description-input mt-2">
                <textarea
                  className="w-100"
                  placeholder="Description"
                  onChange={(e: any) => {
                    newTagInputHandler(e);
                  }}
                />
              </div>
            )}
            <div className="video-popover-footer">
              <div
                className="action-btn cancel-btn mr-2"
                onClick={() => {
                  cancelActionHandler();
                }}
              >
                Cancel
              </div>
              <div
                className={
                  "action-btn add-btn " + (isBtnDisable ? "disabledbutton" : "")
                }
                onClick={() => {
                  addActionHandler();
                }}
              >
                Add
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
  //Actual Component HTML Starts
};

export default VideoTag;
